import { render, staticRenderFns } from "./kspl-thietlap.vue?vue&type=template&id=fdf82738&scoped=true&"
import script from "./kspl-thietlap.vue?vue&type=script&lang=js&"
export * from "./kspl-thietlap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdf82738",
  null
  
)

export default component.exports